import * as React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import "./i18n";
import App from "./App";
import "./assets/sass/theme.scss";

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root"),
);
